import MainPage from '@/entries/widget/page/main.vue';

export const routes = [
    {
        name: 'Home',
        path: '/:widgetId/:extUserId?',
        component: MainPage,
        children: [
            {
                name: 'PayinCrypto',
                path: 'payin-crypto',
                meta: { title: 'PayinCrypto' },
                components: {
                    personal: () => import(/* webpackChunkName: "entries/widget/page/Personal" */ '@/entries/widget/page/Personal'),
                    invoice: () => import(/* webpackChunkName: "entries/widget/page/Invoice" */ '@/entries/widget/page/Invoice'),
                }
            },
            {
                name: 'PayoutCrypto',
                path: 'payout-crypto',
                meta: { title: 'PayoutCrypto' },
                components: {
                    payout: () => import(/* webpackChunkName: "entries/widget/page/Payout" */ '@/entries/widget/page/Payout'),
                }
            },
            {
                name: 'PayinFiat',
                path: 'payin-fiat',
                meta: { title: 'PayinFiat' },
                components: {
                    fiat: () => import(/* webpackChunkName: "entries/widget/page/Fiat" */ '@/entries/widget/page/Fiat'),
                }
            }
        ]
    },
    {
        path: '*',
        redirect: { name: 'Home' }
    },
];

